import {Injectable} from '@angular/core';
import {Headers, Http, RequestOptions, URLSearchParams} from '@angular/http';
import 'rxjs/add/operator/map';
import {Observable} from 'rxjs/Rx';
import {CompanyServiceA2} from "../../core/company_a2.service";
import * as moment from "moment";
import _date = moment.unitOfTime._date;

@Injectable()
export class HomeService {

    private baseUrl: string = '../rest/company/';

    constructor(private http : Http, private companyService: CompanyServiceA2) {}

        getData(companyId:number, dateNow: String): any {
        return Observable.forkJoin([
            this.getCompany(companyId),
            this.getBookings(companyId, dateNow),
        ]);
    }

    getCompany(companyId:number): any {
        return this.companyService.get(companyId);
    }

    getBookings(companyId:number, dateNow:String): any {
        let myParams = this.getBookingRequestParams(dateNow);
        let options = new RequestOptions({ headers: this.getHeaders(), search:myParams });
        return this.http.get(`${this.baseUrl}${companyId}/booking/landing`, options)
            .map((response) => response.json());
    }

    private getHeaders(){
        let myHeaders = new Headers();
        myHeaders.append('Content-Type', 'application/json');
        return myHeaders;
    }

    private getBookingRequestParams(dateNow: String) {
        let myParams = new URLSearchParams();
        myParams.append('dateNow', dateNow.toString());
        return myParams;
    }
}



// WEBPACK FOOTER //
// ./public/upgrade/feature/home/home.service.ts